export const frContacts = {
    'navbar.contacts': 'Annuaire',
    'contacts.list.pageTitle': 'Annuaire',
    'contacts.list.title': 'Annuaire',

    //* CONTACTS LIST
    'contacts.list.actions.addContact': 'Ajouter un contact',

    'contacts.list.filters.departement.label': 'Service',
    'contacts.list.filters.departementFormat': 'Service : {value}',

    'contacts.list.headers.info': 'Informations utilisateur',
    'contacts.list.headers.department': 'Service',
    'contacts.list.headers.position': 'Poste',

    //* CONTACTS REMOVE POPUP
    'contacts.remove.dialog.title': 'Suppression de ce contact',
    'contacts.remove.dialog.content': 'Êtes-vous sûr de vouloir supprimer ce contact ?',

    //* CONTACTS CREATE AND DETAILS
    'contacts.create.pageTitle': 'Création contact',
    'contacts.details.pageTitle': 'Details contact',
    'contacts.details.actions.previous': 'Annuaire',

    //* CONTACTS INFORMATIONS
    'contacts.info.lastName.label': 'Nom',
    'contacts.info.lastname': 'Nom *',

    'contacts.info.firstname.label': 'Prénom',
    'contacts.info.firstname': 'Prénom *',

    'contacts.info.email.title': 'Email',
    'contacts.info.email.placeholder': 'Adresse email *',

    'contacts.info.phone.title': 'Tél Fixe',
    'contacts.info.phone.placeholder': 'Numéro de téléphone fixe',

    'contacts.info.position.title': 'Poste',
    'contacts.info.position.placeholder': 'Titre de poste',


    'contacts.info.mobile.title': 'Mobile',
    'contacts.info.mobile.placeholder': 'Numéro de téléphone portable',

    'contacts.info.department.title': 'Service',
    'contacts.info.department.placeholder': 'Service',

    //* PERMISSIONS
    'backofficeUsers.create.tabs.permissions.toggles.directorieswrite': "Éditer l'annuaire",

    //* TOAST
    'contacts.import.success': 'Bravo! Contacts importés avec succès',

    //* ERRORS
    'toast.apiErrors.CONTACT_EMAIL_ALREADY_EXISTS': 'Un seul contact par email est autorisé',
};
